import Axios from '../axios-instance';

const notificationsAPI = {
  getUserNotifications: data => {
    return Axios.post('/Notifications/getall', data).then(({ data }) => data);
  },
  newNotification: notification => {
    return Axios.post('/Notifications', notification).then(({ data }) => data);
  },
  getNotificationDetail: id => {
    return Axios.get(`/Notifications/${id}`).then(({ data }) => data);
  },
  getSupplierNotifications: () => {
    return Axios.get('/Notifications/supplier').then(({ data }) => data);
  },
  deleteNotification: (data, id) => {
    return Axios.put(`/Notifications/${id}`, data).then(({ data }) => data);
  },
  deleteAll: () => {
    return Axios.put(`/Notifications`, {}).then(({ data }) => data);
  },
  getFile: (id, fileName) => {
    return Axios.get(`/Notifications/${id}/${fileName}`).then(({ data }) => data);
  },
  uploadFile: (id, files) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    return Axios.post(`/Notifications/${id}/File`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(({ data }) => data);
  },
  getNotificationConformed: (notificationId, supplierId, status) => {
    return Axios.get(`/Notifications/GetNotificationConformed/${notificationId}?supplierId=${encodeURIComponent(supplierId)}&status=${status}`).then(({ data }) => data);
  },
  exportToExcel: body => {
      return Axios.post('/Notifications/exportToExcel', body, { responseType: 'arraybuffer' }).then(({ data }) => data);
    },
  getStatus: () => {
    return Axios.get('/Notifications/GetStatus').then(({ data }) => data);
  },
  confirmNotification: (supplierId, notificationId) => {
    return Axios.post(`/Notifications/ConfirmAdhesion/${notificationId}`, JSON.stringify(supplierId), 
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    
  ).then(({ data }) => data);
  },
  changeVisibility: body => {
    return Axios.patch("/Notifications/visualizacion", body);
  }
};

export default notificationsAPI;
